export * from "modules/AppointmentDetails/components/CarDetails/components/XentryStatus/components/XentryStatusModal";
